/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_P_MemoryInputs */

const en_mk_nav_p_memory = /** @type {(inputs: Mk_Nav_P_MemoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company memory`)
};

const id_mk_nav_p_memory = /** @type {(inputs: Mk_Nav_P_MemoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memori perusahaan`)
};

/**
* | output |
* | --- |
* | "Company memory" |
*
* @param {Mk_Nav_P_MemoryInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_p_memory = /** @type {((inputs?: Mk_Nav_P_MemoryInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_P_MemoryInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_p_memory(inputs)
	return en_mk_nav_p_memory(inputs)
});